import { Button } from '@/components/ui/common/Button'

interface IntroScreenProps {
  timeLimit: number
  onStart: () => void
  onComplete?: () => void
  formatTime: (seconds: number) => string
}

export function IntroScreen({
  timeLimit,
  onStart,
  onComplete,
  formatTime
}: IntroScreenProps) {
  const handleStart = () => {
    onStart()
    if (onComplete) {
      onComplete()
    }
  }

  return (
    <div className="flex flex-col items-center gap-6">
      <h1 className="text-center text-2xl font-bold">
        Zadanie z Dopasowaniem Fragmentu Obrazka
      </h1>

      <p className="max-w-lg text-center">
        W tym zadaniu zobaczysz obrazek z brakującym kwadratowym fragmentem. Twoim
        zadaniem jest przeciągnąć pasujący fragment na puste miejsce.
      </p>

      <p className="max-w-lg text-center">
        Przyjrzyj się uważnie obrazkowi i dostępnym fragmentom, aby wybrać ten, który
        dokładnie pasuje do pustego miejsca.
      </p>

      {timeLimit > 0 && (
        <p className="text-center text-sm text-gray-600">
          Na każde zadanie masz {formatTime(timeLimit)} czasu.
        </p>
      )}

      <Button
        className="bg-indigo-600 text-white hover:bg-indigo-700"
        onClick={handleStart}
      >
        Rozpocznij zadanie
      </Button>
    </div>
  )
}
